import mundoestudiante from '../CuestionarioNoDisponible/mundoestudiante.png'
import css from './CuestionarioYaRespondido.module.css'

const CuestionarioYaRespondido = () => (
  <div className={css.main}>
    <img className={css.image} src={mundoestudiante} alt="Mundoestudiante" />
    <p className={css.info}>
      Ya has respondido a esta encuesta. ¡Gracias por tu participación!
    </p>
  </div>
)

export default CuestionarioYaRespondido
